module.exports = __webpack_public_path__ + "static/mindjoy-75122f34b05a450a8bd3bcafc6a31b96.png";